const getColorBranding = ({ branding }: { branding: BrandingState }): string => {
    return branding.color;
};

export default { getColorBranding };
